module.exports = __webpack_public_path__ + "img/xuanchuanxinxi.9f9d2000.jpg";